"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const index_js_1 = require("../utils/index.js");
require("@itwin/itwinui-css/css/badge.css");
/**
 * Helper function that returns one of the preset badge color values.
 */
const getBadgeColorValue = (color) => {
    if (!color) {
        return '';
    }
    return (0, index_js_1.isSoftBackground)(color) ? index_js_1.SoftBackgrounds[color] : color;
};
/**
 * Helper function that returns one of the preset badge status values.
 */
const getStatusValue = (color) => {
    const statuses = ['positive', 'negative', 'warning', 'informational'];
    return color && statuses.includes(color) ? color : undefined;
};
/**
 * A colorful visual indicator for categorizing items.
 * @example
 * <Badge>Label</Badge>
 * <Badge backgroundColor="sunglow">Label</Badge>
 * <Badge backgroundColor="positive">Label</Badge>
 */
const Badge = (props) => {
    const { backgroundColor, style, className, children, ...rest } = props;
    (0, index_js_1.useTheme)();
    // choosing 'primary' status should result in data-iui-status equaling 'informational'
    const reducedBackgroundColor = backgroundColor === 'primary' ? 'informational' : backgroundColor;
    const statusValue = getStatusValue(reducedBackgroundColor);
    const _style = reducedBackgroundColor && !statusValue
        ? {
            '--iui-badge-background-color': getBadgeColorValue(reducedBackgroundColor),
            ...style,
        }
        : { ...style };
    return (React.createElement("span", { className: (0, classnames_1.default)('iui-badge', className), style: _style, "data-iui-status": statusValue, ...rest }, children));
};
exports.Badge = Badge;
exports.default = exports.Badge;
